import React, { useMemo } from 'react';
import './NocMetricCardOverlay.css';
import AcNocmetricCard from './NocmetricCard';
import AcDonutChart from './DonutChart';
// import {metriCardIcons} from './CustomNocMetricCardsIcons';



interface INocMetricCardOverlayProps {
  chargerList: IChargerDetails[] | null
  alarmCounts:IAlarmCounts |null;
}


const AcNocmetricCardOverlay: React.FC<INocMetricCardOverlayProps> = (props) => {
  const { chargerList } = props
  const {alarmCounts} = props
  const totalalarmcount =
  (alarmCounts?.critical ?? 0) +
  (alarmCounts?.major ?? 0) +
  (alarmCounts?.minor ?? 0);

  const allChargerIds = chargerList?.map(c => c.id) ?? [];
  const secondsIn5Days = 60 * 60 * 24 * 5;

    const { totalChargers, onlineChargers, offlineChargers,activeSessions, totalfailedtransactions,activechargerlist,chargersWithFailedTransactions} = useMemo(() => {
    const totalChargers = chargerList?.length || 0;
    const onlineChargers = chargerList?.filter(c => c.status === 'Online')?.length || 0;
    const offlineChargers = totalChargers - onlineChargers;
    const totalCritical = chargerList?.reduce((sum, c) => sum + c?.alarms?.critical, 0) || 0;
    const totalMajor = chargerList?.reduce((sum, c) => sum + c?.alarms?.major, 0) || 0;
    const totalMinor = chargerList?.reduce((sum, c) => sum + c?.alarms?.minor, 0) || 0;
    const totalChronic = chargerList?.reduce((sum, c) => {
      if (c?.alarmSetAt && c?.alarms?.critical && ((Date.now() - new Date(c?.alarmSetAt).getTime()) / 1000) > secondsIn5Days) {
        return sum + c?.alarms?.critical
      }
      return sum;
    }, 0) || 0;
    const totalfailedtransactions = chargerList?.reduce(
      (sum, c) => sum + (c?.c1FailedTransaction ?? 0) + (c?.c2FailedTransaction ?? 0) + (c?.c3FailedTransaction ?? 0),
      0
    ) ?? 0;
    const activeSessions = chargerList?.reduce((sum,c) => sum + (c?.activeChargingSession1 ? 1 : 0) + (c?.activeChargingSession2 ? 1 : 0) + (c?.activeChargingSession3 ? 1 : 0),0) || 0;
    const activechargerlist = chargerList?.filter(c => c?.activeChargingSession1 || c?.activeChargingSession2 || c?.activeChargingSession3).map(c => c.id) ?? [];
    const chargersWithFailedTransactions = chargerList?.filter(c => 
  (c?.c1FailedTransaction ?? 0) > 0 ||
  (c?.c2FailedTransaction ?? 0) > 0 ||
  (c?.c3FailedTransaction ?? 0) > 0
).map(c => c.id) ?? [];

    return { totalChargers, onlineChargers, offlineChargers, totalCritical, totalMajor, totalMinor, activeSessions, totalfailedtransactions, totalChronic ,activechargerlist,chargersWithFailedTransactions}
  }, [chargerList])

  return (
    <div className='noc-card-overlay'>
      <AcNocmetricCard
        color='green'
        cardType='charger'
        allChargerIds={allChargerIds}
        infoTooltipText='1.Total chargers currently displayed on the map.
        2.Pie Chart: Total Online and Offline chargers displayed on the map.'
        heading='Chargers'
        value={totalChargers}
        donutChart={
          <AcDonutChart
            centerText={String(onlineChargers)}
            allChargerIds={allChargerIds}
            donutTitle='Online'
            data={[
              { name: 'Online', value: onlineChargers, color: '#34C759' },
              { name: 'Offline', value: offlineChargers, color: '#C6D0C5' }
            ]}
          />
        }
      />
      <AcNocmetricCard
        color='orange'
        heading='Chronic Alarms'
        cardType='chronic-alarms'
        infoTooltipText='1. Chronic Alarms: Active critical alarms unresolved for more than 5 days.
                         2. Pie Chart: Total active alarms by severity: Critical, Major, Minor.'
        value={alarmCounts?.chronic}
        allChargerIds={allChargerIds}
        // subText={<div style={{ fontSize: '14px', color: '#9D9D9D' }}>Critical alarm for more than a week</div>}
        donutChart={
          <AcDonutChart
            centerText={String(totalalarmcount)}
            allChargerIds={allChargerIds}
            donutTitle='Alarms'
            data={[
              { name: 'Critical', value: alarmCounts?.critical ?? 0, color: '#B3261E' },
              { name: 'Major', value:  alarmCounts?.major  ?? 0, color: '#FE9602' },
              { name: 'Minor', value: alarmCounts?.minor ?? 0, color: '#FFCC00' }
            ]}
          />
        }
      />

      <AcNocmetricCard
        heading='Live Sessions'
        cardType='live-sessions'
        infoTooltipText='Charging sessions currently in progress.'
        allChargerIds={activechargerlist}
        color='blue'
        value={activeSessions}
      />     
      
      <AcNocmetricCard
        color='red'
        cardType='failed-transactions'
        infoTooltipText='The latest completed sessions with zero energy consumption.'
        heading='Failed Transactions'
        value={totalfailedtransactions}
         allChargerIds={chargersWithFailedTransactions}
      // subText='at connector (gun) level'
      />
    </div>
  );
};

export default AcNocmetricCardOverlay;

